module.exports = __webpack_public_path__ + "static/media/desktopBurger.a18eaeb5.svg";